import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Zoom from 'react-reveal/Zoom';

import Socials from "../../components/socials/Socials"
import "./Intro.scss";

class Intro extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.data
        };
    }

    state = {
        hide: false
    };

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
    }

    handleScroll = () => {
        // Title fade on scroll
        if (this.refs.title) {
            let height = this.refs.intro.clientHeight;
            if (window.pageYOffset >= height * 0.25) {
                this.refs.title.classList.add("hide");
                this.setState({ hide: true });
            } else {
                this.refs.title.classList.remove("hide");
                this.setState({ hide: false });
            }
        }
    };

    render() {

        let name = this.state.data.name;
        let profession = this.state.data.profession;
        let socials = this.state.data.socials;

        return (
            <section id="intro" ref="intro">
                <Container fluid className="h-100">
                    <Row className="title-section h-100" ref="title">
                        <Col className="align-self-center">
                            <Zoom>
                                <h3 className="subtitle">
                                    {profession}
                                </h3>
                            </Zoom>
                            <Zoom>
                                <h1 className="title">{name.toUpperCase()}</h1>
                            </Zoom>
                            <Zoom>
                                <div className="seperator"><hr /></div>
                            </Zoom>
                            <Socials data={socials} />
                        </Col>
                    </Row>
                </Container>
            </section>
        );
    }
}

export default Intro;
